import {EventDto} from "../../../interfaces/IEvent";
import {toDateTime} from "../../../utils/ValueFormatters";
import {GridColDef} from "@mui/x-data-grid";
import CustomPagination from "../../../components/DataGrid/Pagination";
import {StripedDataGrid} from "../../../components/DataGrid/StyledComponents";
import {Dialog, DialogContent, DialogTitle, Fab} from "@mui/material";
import DialogCloseButton from "../../../components/Buttons/DialogCloseButton";
import {useState} from "react";
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

interface HistoryContainerProps {
    viewEvent: EventDto;
}

function HistoryContainer({viewEvent}: HistoryContainerProps) {
    const [openHistoryDialog, setOpenHistoryDialog] = useState(false);

    const columns: GridColDef[] = [
        { field: 'changedOn', headerName: 'Fra dato', minWidth: 90, flex: 1,
            valueFormatter: (value, row, column, apiRef) =>
                value ? toDateTime(new Date(value as Date)) : ' ',
        },
        { field: 'changedBy', headerName: 'Endret av', minWidth: 90, flex: 1,
            valueFormatter: (value, row, column, apiRef) => row.changedBy.name
        },
        { field: 'field', headerName: 'Felt', minWidth: 90, flex: 1 },
        { field: 'previousValue', headerName: 'Endret fra', minWidth: 90, flex: 1 },
        { field: 'newValue', headerName: 'Endret til', minWidth: 90, flex: 1 },
    ];

    const unqiueRowId = (event: any) => event.field + event.changedOn + event.changedBy + event.previousValue + event.newValue;

    return (
        <>
            <Dialog
                open={openHistoryDialog}
                onClose={() => setOpenHistoryDialog(false)}
                maxWidth="lg"
                fullWidth
            >
                <DialogTitle sx={{ fontWeight: 600 }}>
                    Historikk
                    <DialogCloseButton handleClose={() => setOpenHistoryDialog(false)} />
                </DialogTitle>
                <DialogContent>
                    <StripedDataGrid
                        getRowId={(event) => event && unqiueRowId(event)}
                        rows={viewEvent.eventChanges}
                        columns={columns}
                        autoHeight
                        showToolbar
                        disableRowSelectionOnClick
                        showCellVerticalBorder={true}
                        showColumnVerticalBorder={true}
                        rowHeight={45}
                        slots={{
                            pagination: CustomPagination,
                        }}
                        initialState={{
                            sorting: {
                                sortModel: [{ field: 'changedOn', sort: 'desc' }],
                            },
                            pagination: { paginationModel: { pageSize: 10 } },
                        }}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                        }
                    />
                </DialogContent>
            </Dialog>
            <Fab
                sx={{
                    position: "fixed",
                    bottom: 20,
                    right: 20,
                }}
                size="medium"
                color="info"
                onClick={() => setOpenHistoryDialog(true)}
            >
                <HistoryOutlinedIcon />
            </Fab>
        </>
    )
}

export default HistoryContainer;